// PRODUCT GALLERY
var LayoutQuickviewModalGallery = function () {
    return {
        //main function to initiate the module
        init: function () {
            $('#quick-view-product-modal .c-product-gallery-content .c-zoom').toggleClass('c-hide'); // INIT FUNCTION - HIDE ALL IMAGES

            // SET GALLERY ORDER
            var i = 1;
            $('#quick-view-product-modal .c-product-gallery-content .c-zoom').each(function(){
                $(this).attr('img_order', i);
                i++;
            });

            // INIT ZOOM MASTER PLUGIN
            /*$('.c-zoom').each(function(){
                $(this).zoom();
            });*/

            // ASSIGN THUMBNAIL TO IMAGE
            var i = 1;
            $('#quick-view-product-modal .c-product-thumb img').each(function(){
                $(this).attr('img_order', i);
                i++;
            });

            // INIT FIRST IMAGE
            $('#quick-view-product-modal .c-product-gallery-content .c-zoom[img_order="1"]').toggleClass('c-hide');

            // CHANGE IMAGES ON THUMBNAIL CLICK
            $('#quick-view-product-modal .c-product-thumb img').click(function(){
                var img_target = $(this).attr('img_order');

                $('#quick-view-product-modal .c-product-gallery-content .c-zoom').addClass('c-hide');
                $('#quick-view-product-modal .c-product-gallery-content .c-zoom[img_order="'+img_target+'"]').removeClass('c-hide');
            });

            // SET THUMBNAIL HEIGHT
            var thumb_width = $('#quick-view-product-modal .c-product-thumb').width();
            $('#quick-view-product-modal .c-product-thumb').height(thumb_width);

        }
    }
}();

$(document).ready( function() {
    $(document).variantPrices();
    $(document).provinceField();

    /*$('body').on('click', '.c-input-group-btn-vertical button', function () {
        var basketQTY = $(this).parent().siblings('.basket-qty');
        if (basketQTY.data("lastval") != basketQTY.val()) {
            basketQTY.data("lastval", basketQTY.val());
            $('#sylius-cart-update').trigger('click');
        }
    });

    $('body').on('input', '.basket-qty', function () {
        var basketQTY = $(this);
        if (basketQTY.data("lastval") != basketQTY.val()) {
            basketQTY.data("lastval", basketQTY.val());
            $('#sylius-cart-update').trigger('click');
        }
    });*/

    $('.address-book-select li').on('click', function() {
        var addressSelected = $(this);
        var element = addressSelected.parents('.a-form');
        var inputs = element.find('input');

        $.each(inputs, function (key, input) {
            $(input).val('');
        });

        var parseKey = function (key) {
            return key.replace(/(_\w)/g, function (m) {return m[1].toUpperCase()});
        }

        $.each(addressSelected.data(), function (key, property) {
            element.find('input[name*='+ parseKey(key) +']').val(property);
        });
    });

    $('.c-radio').find('label').prepend('<span class="inc"></span><span class="check"></span><span class="box"></span>');
    $('.c-checkbox').find('label').prepend('<span class="inc"></span><span class="check"></span><span class="box"></span>');

    $('.c-content-product-2 .c-btn-product').on('click', function(e) {
        $('#quick-view-product-modal').remove();
        var ajaxURL = $(this).data('ajax-url');
        $.get( ajaxURL, function( modalHTML ) {
            $('body').append( modalHTML );
            $('#quick-view-product-modal').modal('toggle');
            if ($('#sylius-variants-pricing').length > 0) {
                handleProductOptionsChange();
            } else if ($("#sylius-product-variants").length > 0) {
                $('#quick-view-product-modal .c-radio').find('label').prepend('<span class="inc"></span><span class="check"></span><span class="box"></span>');

                $('#quick-view-product-modal #sylius-product-variants .c-radio label').on('click', function(e) {
                    $(this).siblings('input').prop("checked", true);
                    var $elem = $(this).parents('.c-shop-product-details-2');
                    var $price = $(this).parents('tr').find('.sylius-product-variant-price').html();
                    $elem.find('#product-price').html($price);
                    $elem.find('#product-price').find('br').remove();
                    e.preventDefault();
                });
            }
            $('#quick-view-product-modal').find('#sylius-product-adding-to-cart').addToCart();
        })/*.done( function() {
            setTimeout( function() {
                LayoutQuickviewModalGallery.init();
            }, 200);
        })*/;
        e.preventDefault();
    });
});


(function ( $ ) {
    'use strict';

    $.fn.extend({

        saveCart: function () {
            var element = $(this);
            var csrfToken = $(element).data('csrf-token');
            var dataUrl = $(element).data('url');

            $(this).on('click', function(e) {

                var listName = $('#isoshop-save-cart-list-name').val();

                if (listName) {

                    $.ajax({
                        method: 'POST',
                        url: dataUrl,
                        cache: false,
                        data: { _csrf_token : csrfToken, name: listName },
                        success: function (response) {
                            alert("Koszyk został zapisany")
                        },
                        error: function(response) {
                            alert("Error");
                        }
                    });

                } else {
                    alert('Podaj nazwę listy');
                }

                e.preventDefault();
            });
        },
        shareCart: function () {
            var element = $(this);
            var csrfToken = $(element).data('csrf-token');
            var dataUrl = $(element).data('url');

            $(this).on('click', function(e) {

                $(this).attr('disabled', 'disabled');

                $.ajax({
                    method: 'POST',
                    url: dataUrl,
                    cache: false,
                    data: { _csrf_token : csrfToken },
                    success: function (response) {
                        //console.log(response);
                        $('#isoshop-shared-cart').html('<strong>'+ response.url +'</strong>');
                    },
                    error: function(response) {
                        alert("Error");
                    }
                });

                e.preventDefault();
            });
        }

    });



})( jQuery );

(function($) {
    $(document).ready(function () {
        $('#isoshop-save-cart').saveCart();
        $('#isoshop-share-cart').shareCart();
    });
})(jQuery);